import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { DialogRef } from '@angular/cdk/dialog';
import {
  SignalButton,
  SignalTextField,
  SignalTextarea,
  State,
} from '@vallift/ngl';
import { BaseComponent } from '@core/base/base-component';
import { WorkspaceAPIService } from '@core/api/workspace/services/workspace-api/workspaceAPI.service';
import type { ContactGroupResponse } from '@core/api/workspace/models/contactGroupResponse';
import type { CreateContactGroupApiResponse } from '@core/api/workspace/models/createContactGroupApiResponse';

export type CreateGroupOverlayResult = ContactGroupResponse;

@Component({
  selector: 'app-create-group-overlay',
  standalone: true,
  imports: [SignalButton, SignalTextField, SignalTextarea],
  templateUrl: './create-group-overlay.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateGroupOverlayComponent extends BaseComponent {
  private readonly userAPIService = inject(WorkspaceAPIService);
  private readonly dialogRef = inject(
    DialogRef<CreateGroupOverlayResult | null>,
  );

  readonly createState = new State<CreateContactGroupApiResponse>();
  readonly name = signal('');
  readonly description = signal('');

  close(): void {
    this.dialogRef.close(null);
  }

  onSave(): void {
    const name = this.name().trim();
    const description = this.description().trim();

    if (!name) {
      this.toasterService.error('Enter a group name.');
      return;
    }

    this.executeRequest({
      state: this.createState,
      request: this.userAPIService.createContactGroup({
        name,
        ...(description ? { description } : {}),
      }),
      showLoader: true,
      handleError: true,
      onSuccess: (response) => {
        this.toasterService.success('Group created.');
        this.dialogRef.close(response.data);
      },
    });
  }
}
